import { IDataProvider } from "../Data/IDataProvider";
import IDream, { resourceNameDream } from "../Entity/IDream";

const DreamRepository = () => {
    async function UpdateDreamAsync(
        dream: IDream,
        dataProvider: IDataProvider
    ) {
        await dataProvider.UpdateRecordAsync(
            `${resourceNameDream}?id=eq.${dream.id}`,
            dream
        );
    }

    return {
        UpdateDreamAsync,
    };
};

export const dreamRepository = DreamRepository();
